/* PDP flash-sale countdown.
 * Each [data-hm-countdown] has a data-sale-end ISO datetime; this updates its
 * [data-hm-countdown-value] every second and hides the block once it expires. */

function startCountdown(el) {
  if (el.dataset.hmCountdownStarted) return;
  const out = el.querySelector('[data-hm-countdown-value]');
  const end = new Date(el.dataset.saleEnd).getTime();
  if (!out || Number.isNaN(end)) return;
  el.dataset.hmCountdownStarted = 'true';

  const pad = (n) => String(n).padStart(2, '0');

  let timer;

  const render = () => {
    if (!el.isConnected) {
      if (timer) clearInterval(timer);
      return;
    }

    const diff = end - Date.now();
    if (diff <= 0) {
      el.hidden = true;
      if (timer) clearInterval(timer);
      return;
    }
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    out.textContent = `${d}D:${pad(h)}H:${pad(m)}M:${pad(s)}S`;
  };

  render();
  timer = setInterval(render, 1000);
}

function init() {
  document.querySelectorAll('[data-hm-countdown]').forEach(startCountdown);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', init);
document.addEventListener('hm:pdp-countdown:refresh', init);
